import { Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PriceListTransferFee } from '../../../models/pricelist-transfer.model';
import { CompanyEnum } from '../../../models/company.model';
import { AlpTransferFeeDataTable, AlpTransferFeeLabels, Note } from '../../../models/types';
import { getBandFromMinMax } from '../../../utils/table-utils';
import { PricePipe } from '@lx/shared/ui/pipes';
import { extractNotes } from '../../../utils/pricelist.functions';
import { NotesComponent } from '../../notes/notes.component';
import { TableModule } from 'primeng/table';
import { PriceListTransferFeeBandsService } from '../../../services/pricelist-transfer-fee-bands.service';

@Component({
  standalone: true,
  imports: [CommonModule, PricePipe, NotesComponent, TableModule],
  selector: 'lx-price-lists-portal-alp-transfer-table',
  templateUrl: './alp-transfer-table.component.html',
  styleUrls: ['./alp-transfer-table.component.scss'],
})
export class AlpTransferTableComponent implements OnInit {
  @Input() transfers: PriceListTransferFee | undefined;

  dataSource: AlpTransferFeeDataTable[] = [];
  columnLabels: AlpTransferFeeLabels | undefined;
  notes: Note[] | undefined;
  notationMarks: Record<string, string> | undefined;

  company = CompanyEnum.ALP;

  private readonly priceListTransferFeeBandsService = inject(PriceListTransferFeeBandsService);

  ngOnInit(): void {
    if (this.transfers?.products) {
      this.dataSource = this.transfers.products.map(({ name, prices }) => {
        const pricesByBand = prices?.reduce<Record<string, number>>((prices, { price, duration: { min, max } }) => {
          const band = getBandFromMinMax(min, max);
          const newPrices = { ...prices };
          newPrices[band] = price;
          return newPrices;
        }, {});
        return {
          name,
          prices: pricesByBand,
        };
      });

      this.columnLabels = this.priceListTransferFeeBandsService.getColumnLabels(this.transfers);
    }
    if (this.transfers?.notes) {
      [this.notes, this.notationMarks] = extractNotes(this.transfers.notes);
    }
  }
}
